<template>
  <sw-modal :open="$attrs.open" @close="$emit('close')">
    <div class="export-modal">
      <span
        slot="header"
        class="flex center base-modal-title"
      >{{dictionnary ? dictionnary.exportModal.title: ''}}</span>
      <span class="export-modal-content">{{dictionnary ? dictionnary.exportModal.content:''}}</span>

      <div class="export-modal-buttons">
        <a class="flex button-export-modal center vertical" ref="png" @click="exportImage('png')">
          <span class="sprite-png export-modal-buttons-icon"/>
          EXPORT BASE 64
        </a>
        <a
          class="flex button-export-modal center vertical"
          ref="png"
          download="mypicture.png"
          @click="saveImage('png')"
        >
          <span class="sprite-png export-modal-buttons-icon"/>
          {{dictionnary ? dictionnary.exportModal.png : ''}}
        </a>
        <a
          class="flex button-export-modal center vertical"
          ref="jpeg"
          download="mypicture.jpg"
          @click="saveImage('jpeg')"
        >
          <span class="sprite-jpg export-modal-buttons-icon"/>
          {{dictionnary ? dictionnary.exportModal.jpg : ''}}
        </a>
      </div>
    </div>
  </sw-modal>
</template>
<script>
//////////////////////////////////////
// IMPORT
/////////////////////////////////////
import { mapGetters } from 'vuex'
//////////////////////////////////////
// CLASS
/////////////////////////////////////
export default {
  name: 'PictureSaveModal',
  components: {},
  beforeCreate() {},
  async created() {
    this.dictionnary = await this.getLanguages
    this.editor.on('onExport', data => (this.test = data))
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      dictionnary: null,
      test: null
    }
  },
  props: {
    editor: Object
  },
  computed: {
    ...mapGetters(['getLanguages'])
  },
  methods: {
    saveImage(format) {
      let data = null
      this.$refs[format].href = this.editor.savePicture(format, 1)
    },
    exportImage(format) {
      let data = null
      window.parent.postMessage(
        {
          event: 'image',
          data: this.editor.savePicture(format, 1)
        },
        '*'
      )
    }
  },
  watch: {}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/modal/PictureSaveModal.vue